import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { TaskProductManifestItemStaged } from '@euler/model/task-detail';
import { memo } from 'react';
import { CheckItemInfo } from '../functions/SiteInspection';
import {
  ItemInspectionCallbackProps,
  ItemInspectionView,
} from './ItemInspectionView';

type Props = {
  items: CheckItemInfo[];
  canAssociateProduct: boolean;
  productManifestItems: TaskProductManifestItemStaged[];
} & ItemInspectionCallbackProps;

export const SiteInspectionView = memo(
  ({
    items,
    canAssociateProduct,
    productManifestItems,
    ...callbackProps
  }: Props) => {
    const { rpx } = useResponsiveContext();
    return (
      <>
        {items.map((item, index) => (
          <ItemInspectionView
            key={item.key}
            itemNo={index + 1}
            item={item}
            canAssociateProduct={canAssociateProduct}
            productManifestItems={productManifestItems}
            {...callbackProps}
            css={`
              margin-top: ${index === 0 ? rpx(15) : 0}px;
              margin-left: ${rpx(15)}px;
              margin-right: ${rpx(15)}px;
              margin-bottom: ${rpx(15)}px;
              border-radius: ${rpx(5)}px;
            `}
          />
        ))}
      </>
    );
  },
);
